import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

import { ChangeUserDetailsRequest } from '@vi-iot/client';

import { LANGUAGES } from '@store';
import { LanguageDetailsFormGroup } from './other-details.helper';

@Component({
  selector: 'app-other-details',
  templateUrl: './other-details.component.html',
  styleUrls: ['./other-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OtherDetailsComponent implements OnInit {
  formGroup: FormGroup<LanguageDetailsFormGroup>;
  languages = LANGUAGES;

  @Input() details: {
    language: string;
  };

  @Output() cancel: EventEmitter<void> = new EventEmitter<void>();

  @Output() save: EventEmitter<ChangeUserDetailsRequest> = new EventEmitter<
    ChangeUserDetailsRequest
  >();

  ngOnInit(): void {
    const language = this.parseLanguageCode(this.details.language);
    this.formGroup = new FormGroup<LanguageDetailsFormGroup>({
      language: new FormControl<string>(language),
    });
  }

  onCancel(): void {
    this.cancel.emit();
  }

  onSave(): void {
    this.save.emit({
      languageCode: this.formGroup.value.language,
    });
  }

  private parseLanguageCode(language: string): string {
    if (language) {
      const locale = language.split('-');
      if (locale[0]) {
        return locale[0].toLowerCase();
      } else {
        return language;
      }
    }

    return '';
  }
}
